import { useEffect, useState } from 'react';
import { Button, Modal } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';
import DynamicTableModalComponent from '../../DynamicTable/DynamicTableModalComponent';
import { v4 as uuid } from 'uuid';

function LinkExisting() {
  const { mediaAssetStore, reportStore, activityStore, clonedStore } =
    useStore();
  const {
    filmFestivalOnlyByDate,
    loadExistingData,
    dataCheckbox,
    LinkExistingConnect,
    LinkExsitingArray,
  } = reportStore;
  const { selectedActivity: activity } = activityStore;

  const [showText, setShowText] = useState(false);
  const [currentPage, setCurrentPage] = useState<any>(1);

  useEffect(() => {
    loadExistingData(activityStore.selectedActivity?.id);
  }, [
    loadExistingData,
    mediaAssetStore.mediaAsset.refreshSectionMain,
    activityStore.selectedActivity?.id,
  ]);

  const removeCol = 'type,deleted';

  const assettable = JSON.parse(JSON.stringify(filmFestivalOnlyByDate));
  assettable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));
  // assettable.map((i: any) => delete i.name);

  useEffect(() => {
    setShowText(true);
  }, []);
  const submitFun = () => {
    const p1 = new Promise(async (resolve) => {
      mediaAssetStore.setOpenSectionsExiste(false);
      LinkExistingConnect(true);
      loadExistingData(activityStore.selectedActivity?.id);
      dataCheckbox(activity?.id);
      mediaAssetStore.mediaAsset.refreshSectionMain =
        !mediaAssetStore.mediaAsset.refreshSectionMain;
      resolve('');
    });
    p1.then(() => {
      setTimeout(() => {
        clonedStore.loadSectionById(activity?.id + '/' + activity?.title);
      }, 250);
    });
  };

  return (
    <Modal
      className="LinkExisting-Modal-header"
      // style={{}}
      // onClose={() => mediaAssetStore.setOpenSectionsExiste(false)}
      onOpen={() => mediaAssetStore.setOpenSectionsExiste(true)}
      open={mediaAssetStore.mediaAsset.openSectionExiste}
    >
      <Modal.Header>Link Existing</Modal.Header>
      <Modal.Content image>
        <Modal.Description style={{ width: '100%' }}>
          {showText && (
            <DynamicTableModalComponent
              key={uuid()}
              data={assettable}
              name={'LinkExising'}
              actiontype={''}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => mediaAssetStore.setOpenSectionsExiste(false)} //  disabled={}
        >
          Close
        </Button>
        <Button
          color="blue"
          disabled={!LinkExsitingArray.length}
          onClick={submitFun} //  disabled={}
        >
          Submit
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
export default observer(LinkExisting);
